var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("title"),_c('img',{staticClass:"icon-right",attrs:{"src":require("@/assets/pc/icon_arrow down.svg"),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }